import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { FileItem, HttpClientUploadService } from '@wkoza/ngx-upload';
import { MessagesService } from '@core/_services/messages.service';
import { ApiV6Service } from '@service/apiv6.service';
import { EditorService } from '@service/editor.service';
import {
    infosMail,
    currentBskProperty,
    setInfosMail,
    prepareFileName,
} from '@core/_utils/tools.utils';
import { indexInputMode } from '@documalis/_const/const';
import { DynIndexService } from '@service/dynindex.service';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, lastValueFrom, map } from 'rxjs';
import { AddFileService } from '@service/addfile.service';
import { IndexedDbService } from '@service/indexeddb.service';

@Component({
    selector: 'addfile',
    templateUrl: 'addfile.component.html',
    styleUrls: ['addfile.component.scss'],
})
export class AddFileComponent implements OnInit, OnChanges {
    @Input() public uploadForm;
    @Input() public uploader: HttpClientUploadService;
    @Input() public bskName;
    @Input() public bskLabel;
    @Input() public bskType;

    @Input() public baseRoot;
    @Input() public storagePath;
    @Input() public priority;

    @Input() public usePreProcess;
    @Input() public preProcessName;
    @Input() public parameterList;
    @Input() public indexInputMode;
    @Input() public ctrlDouble;

    @Input() // @Output()
    public visible: boolean;
    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();
    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();
    @Output()
    public onRemoveItem: EventEmitter<any> = new EventEmitter();

    public displayIndex: boolean = false;
    public currentIndex: number = 0;
    public currentFile = '';
    public bskDocAddList: any[];
    public backupIndex: any[];
    public saveInfoMail: infosMail;
    public currentBskProperty: currentBskProperty;
    public enterVariable: boolean = false;
    public requiredVariable: boolean = false;
    public disabledSend: boolean = true;
    public displayStop: boolean = false;

    public error = false;
    public currentVarList: any[];
    public currentInfosMail: any;

    public isLoadingRequest: boolean = true;

    constructor(
        protected _messageService: MessagesService,
        public editorService: EditorService,
        private api: ApiV6Service,
        private translate: TranslateService,
        private addFileService: AddFileService,
        private indexedDbService: IndexedDbService
    ) {
        this.bskDocAddList = new Array();
        this.backupIndex = new Array();
        this.currentVarList = new Array();
        this.currentInfosMail = new Object();
    }

    public ngOnInit() {
        this.currentBskProperty = {
            bsk_docdate: '',
            bsk_docstatus: '',
            bsk_wkfid: '',
            bsk_mailaction: '',
            bsk_maillimit: '',
            bsk_mailurgent: '',
            bsk_mailconf: '',
        };
        this.getVarBsk(this.bskType, this.bskName);
    }

    public ngOnChanges() {}

    private async getVarBsk(aBskType, aBskName) {
        this.isLoadingRequest = true;
        await this.execgetBskVariableList(aBskType, aBskName);
        this.isLoadingRequest = false;
    }

    private async execgetBskVariableList(aBskType, aBskName) {
        let wRes: any;
        let wBskVariableList = [];
        try {
            wRes = await lastValueFrom(this.getVarTrsBsk(aBskType, aBskName));      
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant(error.error.CodeMessage));
            return;
        }
        this.editorService.setCustomEditorList(wRes.getEditorList.CustomEditorList);
        this.editorService.setMode(true);
        this.editorService.variableListService.parseService.setBasketName(aBskName);
        wBskVariableList = JSON.parse(
            JSON.stringify(
                this.editorService.formatVarList(this.editorService.variableListService.execParse(wRes.getBskVariableList))
            )
        );
        this.enterVariable = this.addFileService.getEnterVariable(wBskVariableList);
        this.requiredVariable = this.getRequiredVariable(wBskVariableList);
        this.backupIndex = wRes.getBskVariableList;
        // variable présente : affichage de l'icone de saisie
        if (aBskType === 'btMail') {
            this.enterVariable = true;
            this.requiredVariable = true;
        } else {
            this.setModeEnter();
        }
        this.bskDocAddList = [];
        this.setDocAddList();
    }

    private getVarTrsBsk(aBskType, aBskName) {
        const wDataRequest = { 
            baskettype: aBskType, basketname: aBskName };
        return forkJoin([
            this.api.getCustomEditorlist(),
            this.api.execUrlAction('getbskvariablelist', wDataRequest)
        ]).pipe(
            map(([getEditorList, getBskVariableList]) => {
                return { getEditorList, getBskVariableList };
            })
        );
    }

    public setDocAddList() {
        let wAddFile: any;
        let wInfosMail: infosMail;
        let wEditor: EditorService;
        let wId: FormDataEntryValue;
        this.uploader.queue.map((item) => {
            wId = item.formData.get('done');
            if (wId === null) {
                item.formData.append('done','done');
                wAddFile = new Object();
                wInfosMail = setInfosMail(true, '', this.translate);
                wEditor = new EditorService(new DynIndexService(), this.editorService.variableListService, this.translate, this.indexedDbService);
                wAddFile.fileName = item.file.name;
                wEditor.setMode(true);
                wEditor.variableListService.parseService.setBasketName(this.bskName);
                wAddFile.varList = JSON.parse(
                    JSON.stringify(wEditor.formatVarList(wEditor.variableListService.execParse(this.backupIndex)))
                );
                wAddFile.saveIndex = false;
                wAddFile.infosMail = wInfosMail;
                wAddFile.editorService = wEditor;
                this.bskDocAddList = this.bskDocAddList.filter((item) => {
                    return item.fileName.toLowerCase() !==  wAddFile.fileName.toLowerCase();
                })
                this.bskDocAddList.push(wAddFile);
            }
        });
        this.disabledSend = !this.verifyValidIndex(this.bskDocAddList);
    }

    private setModeEnter() {
        if (this.indexInputMode === indexInputMode[0]) {
            // Non requis
            this.disabledSend = false;
        } else {
            if (this.indexInputMode === indexInputMode[1]) {
                // Ne rien demander
                this.enterVariable = false;
                this.requiredVariable = false;
            } else {
                // Normal
                this.disabledSend = true;
            }
        }
    }

    private updatebskDocAddList(aName) {
        this.bskDocAddList = this.bskDocAddList.filter((item) => {
            return item.fileName.toLowerCase() !== aName.toLowerCase();
        });
        this.onRemoveItem.emit(aName);
    }

    private getRequiredVariable(abskVariableList) {
        let wRes = false;
        for (const item of abskVariableList) {
            if (item.system === 'false' && item.type !== 'separator' && item.Required === true) {
                wRes = true;
                break;
            }
        }
        return wRes;
    }

    public activeRemoveAllBtn(): boolean {
        return this.uploader.queue.some((item) => item.isReady || item.isCancel || item.isError);
    }

    public activeUploadAllBtn(): boolean {
        return this.uploader.queue.some((item) => item.isReady);
    }

    public activeCancelAllBtn(): boolean {
        return this.uploader.queue.some((item: FileItem) => item.uploadInProgress);
    }

    public removeItem(aItemFile) {
        this.updatebskDocAddList(aItemFile.file.name);
        this.disabledSend = !this.verifyValidIndex(this.bskDocAddList);
        aItemFile.remove();
        this.uploadForm.reset();
        if (this.uploader.queue.length === 0) {
            this.close(null);
        }
    }

    public removeAll(event) {
        this.uploader.removeAllFromQueue();
        this.uploader.queue = [];
        this.close(event);
    }

    addDataToFile(item: FileItem, aData, abskType, abskName) {
        let wjson = '';
        let wFileName = '';
        wFileName = prepareFileName(item.file.name, 64, false);

        wjson = JSON.stringify(this.addFileService.getDocumentList());
        item.formData.append('DocumentList', wjson);
        wjson = JSON.stringify(this.addFileService.getDocument(wFileName, item.file.size, this.baseRoot, this.storagePath));
        item.formData.append('Document', wjson);
        wjson = this.addFileService.prepareVarList(aData.varList, aData.editorService);
        item.formData.append('Variable', wjson);
        wjson = JSON.stringify(this.addFileService.getRequestSend(aData.infosMail, abskType, abskName));
        item.formData.append('BasketEngine', wjson);
        if (this.usePreProcess) {
            wjson = JSON.stringify(this.addFileService.getPreProcess(this.preProcessName, this.parameterList));
            item.formData.append('PreProcess', wjson);
        }
        item.formData.append('priority', this.priority);
    }

    // Saisie / modification des index
    public setIndex(aData, aIndex) {
        this.bskDocAddList[aIndex].editorService.setChangeDyn(false);
        this.saveInfoMail = setInfosMail(true, '', this.translate);
        this.saveInfoMail = this.addFileService.setInfosMail(this.bskDocAddList[aIndex].infosMail, this.translate);
        this.currentFile = aData.fileName;
        this.displayIndex = true;
        this.currentVarList = JSON.parse(JSON.stringify(this.bskDocAddList[aIndex].varList));
        this.currentInfosMail = setInfosMail(true, '', this.translate);
        this.currentInfosMail = this.addFileService.setInfosMail(this.bskDocAddList[aIndex].infosMail, this.translate);
        this.currentIndex = aIndex;
    }

    public closeIndex() {
        this.displayIndex = false;
    }

    // Enregistrement de la saisie des index
    public onClickSaveIndex() {
        if (this.saveIndex() === false) {
            return;
        }
        this.disabledSend = !this.verifyValidIndex(this.bskDocAddList);
        this.displayIndex = false;
    }

    public onClickSaveOther() {
        if (this.saveIndex() === false) {
            return;
        }

        for (let i = 0; i < this.bskDocAddList.length; i++) {
            if (this.bskDocAddList[i].saveIndex === false) {
                this.saveData(i, this.currentVarList, this.currentInfosMail);
                this.bskDocAddList[i].saveIndex = true;
                this.updateDocAddList(i);
            }
        }
        this.disabledSend = !this.verifyValidIndex(this.bskDocAddList);
        this.displayIndex = false;
    }

    private saveIndex() {
        this.currentVarList = this.bskDocAddList[this.currentIndex].editorService.setValueForUpdate(
            this.bskDocAddList[this.currentIndex].varList
        );
        if (this.verifyData(this.bskDocAddList[this.currentIndex].editorService) === false) {
            return false;
        }
        this.saveData(this.currentIndex, this.currentVarList, this.currentInfosMail);
        this.bskDocAddList[this.currentIndex].saveIndex = true;
        this.updateDocAddList(this.currentIndex);
        return true;
    }

    private saveData(aIndex, aVarList, aInfosMail) {
        this.bskDocAddList[aIndex].varList = [];
        this.bskDocAddList[aIndex].varList = JSON.parse(JSON.stringify(aVarList));
        this.bskDocAddList[aIndex].infosMail.dateLimit = aInfosMail.dateLimit;
        this.bskDocAddList[aIndex].infosMail.mailAction = aInfosMail.mailAction;
        this.bskDocAddList[aIndex].infosMail.mailConf = aInfosMail.mailConf;
        this.bskDocAddList[aIndex].infosMail.mailLimit = aInfosMail.mailLimit;
        this.bskDocAddList[aIndex].infosMail.mailUrgent = aInfosMail.mailUrgent;
        this.bskDocAddList[aIndex].infosMail.status = aInfosMail.status;
    }

    private verifyData(aEditorService) {
        let wMess = '';
        wMess = aEditorService.verifyPattern(this.currentVarList);
        if (wMess !== '') {
            this._messageService.addErrorNoStick(this.translate.instant('Ent_NotValid') + '\n' + wMess);
            return false;
        }

        if (this.indexInputMode === indexInputMode[2]) {
            wMess = aEditorService.verifyRequiredIndex(this.currentVarList);
            if (wMess !== '') {
                this._messageService.addErrorNoStick(this.translate.instant('Miss_IdxReq') + '\n' + wMess);
                return false;
            }
        }
    }

    private updateDocAddList(aIndex) {
        this.bskDocAddList[aIndex].varList.forEach((item) => {
            this.addFileService.updateItem(item, this.bskDocAddList[aIndex].editorService);
        });
    }

    public onClickAdd(event) {
        this.displayStop = true;
        this.uploader.queue.map((item, index) => {
            // prise en compte des variables cachées récup des valeurs par défault qd il n'ya pas d'index à saisir
            if (this.enterVariable === false) {
                this.updateDocAddList(index);
            }
            this.addDataToFile(item, this.bskDocAddList[index], this.bskType, this.bskName);
        });
        this.uploader.uploadAll({
            method: 'POST',
            url: this.getServer(),
        });
    }

    private getServer() {
        if (this.usePreProcess === true) {
            return this.api.execGetUrlGedAction('collectadddoc', '');
        } else {
            return this.api.execGetUrlGedAction('senddocument', '');
        }
    }

    public onClickStop(event) {
        this.uploader.cancelAll();
        this.onCancel.emit(event);
    }

    public close(event) {
        this.onClose.emit(event);
    }

    public clickSetIndex(event) {
        this.setIndex(event.item, event.index);
    }

    private verifyValidIndex(abskDocAddList) {
        if (this.enterVariable === false) {
            return true;
        }
        let wCount = 0;
        for (const item of abskDocAddList) {
            if (item.saveIndex === true) {
                wCount++;
            }
        }
        if (wCount === abskDocAddList.length) {
            return true;
        } else {
            return false;
        }
    }
}
